export default "__VITE_ASSET__39179363__"